themeBase.requestIdleCallback(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    themeBase.onFirstScroll(!themeBase.isDesktop || !window.themeSettings.fullWidthLogoEnabled ? true : false, () => {
      class AppearanceEffect {
        constructor() {
          this.load();
        }

        load() {
          this.offset = 50;
          this.distance = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--animated-appearance-translate')) * 10;
          this.inRowTimeout = Math.min(200, parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--animated-appearance-duration')) / 5);
          this.threshold = this.offset + this.distance;
          this.animate = false;

          this.reload();
          window.addEventListener('MutationObserverLoaded', this.reload.bind(this));
          window.addEventListener('fastScrollDistanceDisabled', () => {
            this.animate = false;
            this.onProcess();
            this.animate = true;
          });
          window.addEventListener('throttle60fpsScroll', () => this.animate = true, {
            once: true
          });
          window.addEventListener('throttle30fpsMove', this.onProcess.bind(this));
          document.body.classList.add('animated-appearance-loaded');
        }

        onMutationObserver() {
          this.updateElements();
          this.onProcess();
        }

        reload() {
          this.updateElements();
          this.onProcess();
        }

        updateElements() {
          if (window.themeScrollTracker?.isFastScrollDistance) return;

          this.elements = new Map(
            [...document.querySelectorAll('.animated-appearance')].map((el, index) => [el, index])
          );

          this.elementsIndex = [...this.elements].reduce((acc, [el, index]) => {
            acc[index] = el;
            return acc;
          }, {});
        }



        visibleFinish(element, slider) {
          this.elements.delete(element);
          element.classList.remove('animated-appearance');

          if (
            slider &&
            (!slider.querySelector('.animated-appearance.animated-appearance--animate'))
          ) {
            slider.querySelector('.slider, .slideshow').classList.remove('slider-component--appearance-preload');
            slider.querySelectorAll('.animated-appearance').forEach(element => element.classList.remove('animated-appearance'));
          }
        }

        animateElement(element, timeoutIndex) {
          element.classList.add('animated-appearance--caught', 'animated-appearance--animate');

          element.addEventListener('transitionend', (e) => {
            if (e.target !== element) return;

            this.visibleFinish(element, themeBase.isSlider(element));
          }, {
            once: true
          });

          setTimeout(() => {
            element.classList.add('animated-appearance--visible');
          }, this.inRowTimeout * timeoutIndex);
        }

        onProcess() {
          if (window.themeScrollTracker?.isFastScrollDistance) return;

          const animateElements = [];

          for (const [element, index] of this.elements) {
            const bounds = themeBounds.get(element);
            const slider = themeBase.isSlider(element);
            const outOfSlider = slider && !themeBase.isInViewport({
              bounds,
              threshold: 0,
              parentBounds: themeBounds.get(slider),
              onlyHorizontal: true
            });

            if (themeBase.isInViewport({
                bounds,
                threshold: this.threshold,
                onlyVertical: slider
              })) {
              if (
                !this.animate ||
                !themeBase.pageLoaded ||
                outOfSlider
              ) {
                if (outOfSlider) {
                  slider.querySelector('.slider').classList.add('slider-component--appearance-preload');
                }

                this.visibleFinish(element);
              } else if (!element.classList.contains('animated-appearance--caught')) {
                animateElements.push({
                  element,
                  bounds
                });
              }
            } else {}
          }

          animateElements.sort((a, b) => {
            return Math.abs(a.bounds.top - b.bounds.top) > 10 ? a.bounds.top - b.bounds.top : a.bounds.left - b.bounds.left;
          });


          for (let index = 0; index < animateElements.length; index++) {

            this.animateElement(animateElements[index].element, index);
          }
        }

        cleanHTMLWithEffect(html) {
          return html.replace(/animated-appearance/gs, '');
        }
      }

      window.appearanceEffect = new AppearanceEffect;
























    });
  });
});